import { OrderSentEvent } from '@toro/common/shared/models/segment/order-sent-event.model';
import { Component, ViewEncapsulation, ViewChild, OnDestroy, HostListener, AfterContentInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TrWarrantyUsageComponent } from '../common/tr-warranty-usage/tr-warranty-usage.component';
import { CheckoutScenarioSettings } from '../checkout-scenario.settings';
import { UtilitiesService } from '@toro/common/shared/services/utilities.service';
import { DialogsService } from '@toro/common/shared/services/dialogs.service';
import { Router, ActivatedRoute } from '@angular/router';
import { InvestmentResumeComponent } from '../dialogs/investment-resume/investment-resume.component';
import { CheckoutCommonResources } from '../common/checkout-common-resources/checkout-common-resources';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { StocksMarketAction } from '@toro/common/shared/state-management/stocks-market/stocks-market.action';
import { MatDialogRef } from '@angular/material/dialog';
import { StocksExchangeCheckoutAction } from '../../../../state-management/stocks-exchange-checkout/stocks-exchange-checkout.action';
import { StockCheckoutType } from '@toro/common/shared/models/stocks-exchange/stock-checkout.model';
import { StockOrderType } from '@toro/common/shared/models/stocks-exchange/stock-order.model';
import { StrategyRequestLegPriceType } from '@toro/common/shared/models/stocks-exchange/strategy-request-leg-price-type.enum';
import { StrategyRequestLegValidityType } from '@toro/common/shared/models/stocks-exchange/strategy-request-leg-validity-type.enum';
import { StrategyRequestOrderType } from '@toro/common/shared/models/stocks-exchange/strategy-request-order-type.enum';
import { StocksExchangeCheckoutEffects } from '../../../../state-management/stocks-exchange-checkout/stocks-exchange-checkout.effects';
import { ApplicationMessagesAction } from '@toro/common/shared/state-management/application-messages/application-message.action';
import { UtilsAction } from '@toro/common/shared/state-management/utils/utils.actions';
import { UtilsState } from '@toro/common/shared/state-management/utils/utils.reducer';
import { OrderMarketTypeEnum } from '@toro/common/shared/enum/orders/market-type.enum';
import { ComputerService } from '@toro/common/shared/services/computer/computer.service';
import { MarketScenario } from '@toro/common/shared/enum/market-scenario/market-scenario.enum';
import { CalculatingScenario } from '@toro/common/shared/enum/calculating-scenario/calculation-scenario.enum';
import { ComputingParameter } from '@toro/common/shared/models/computing-parameter/computing-parameter.model';
import { Subscription } from 'rxjs/Subscription';
import { DatePipe, Location } from '@angular/common';
import { OrderStatus } from '@toro/common/shared/enum/orders/order-status.enum';
import { StocksMarketState } from '@toro/common/shared/state-management/stocks-market/stocks-market.reducer';
import { fadeInOut } from '@toro/common/shared/animations/fadeInOut';
import { StocksExchangeWalletAction } from '@toro/common/shared/state-management/stocks-exchange-wallet/stocks-exchange-wallet.action';
import { OrderSideEnum } from '@toro/common/shared/enum/orders/side.enum';
import { OrderPriceTypeEnum } from '@toro/common/shared/enum/orders/price-type.enum';
import { OrderValidityTypeEnum } from '@toro/common/shared/enum/orders/validy-type.enum';
import { BillingAction } from '../../../../state-management/billing/billing.action';
import { BrokeragePlatform } from '@toro/common/shared/enum/billing/brokerage-platform.enum';
import { BillingEffects } from '../../../../state-management/billing/billing.effects';
import { RouterTrackerService } from '@toro/common/shared/services/router-tracker/router-tracker.service';
import { HubAuthorizationComponent } from '@toro/common/shared/components/hub-authorization/hub-authorization.component';
import { IStressResponse } from '@toro/common/shared/interfaces/pos-risk/stress.interface';
import { SegmentCheckoutTypeEnum } from '@toro/common/shared/enum/segment/segment-checkout-type.enum';
import { SegmentMarketTypeEnum } from '@toro/common/shared/enum/segment/segment-market-type.enum';
import { SegmentOrderSideEnum } from '@toro/common/shared/enum/segment/segment-order-side.enum';
import { STOCK_LOGO_PLACEHOLDER } from '@toro/common/shared/resources/consts';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';
import { StocksMarketInteractionsService } from '../../services/stocks-market-interactions.service';
import { Icvm617Service } from '@toro/common/shared/services/icvm-617';
import { SuitabilityBypassAgreementActions } from '../../../../state-management/suitability-bypass-agreement/suitability-bypass-agreement.action';
import { combineLatest, merge } from 'rxjs';
import { filter, first, map } from 'rxjs/operators';

const disclaimerEasterEggTriggerAmount = 3;
const easterEggKey = 'T';

@Component({
    selector: 'stockhome',
    templateUrl: './unplanned-checkout.component.html',
    styleUrls: [ './unplanned-checkout.component.scss' ],
    animations: [
        fadeInOut,
    ],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class UnplannedCheckoutComponent extends CheckoutCommonResources implements AfterContentInit, OnDestroy {

    public get tooltipDayTrade() {
        return `<div>
            <div class='pop-title'>Após ${ this.timeLimitToDaytrade  }</div>
            <div class='pop-content'>O investimento vai ser encerrado no fim do dia, antes do mercado fechar. </div>
        </div>`;
    }

    get gainLossPerPoint(): number { return this.form.get('stocksCount').value * this.symbol.quoteFactor; }
    get stocksCountErrorMessage(): string { return ''; }
    get customPriceErrorMessage(): string { return ''; }
    get isFuture(): boolean { return this.symbol && this.symbol.typeMarket === OrderMarketTypeEnum.Future; }
    get avaliableValueToInvest() { return this.warranyUsageComponent.avaliableValue; }
    get isDayTrade(): boolean { return this.form.controls.enableDayTrade.value && this.daytradeStress !== 0 && this.usingWarranty; }

    get showCalculusDataEasterEgg() {
        return this.counter === disclaimerEasterEggTriggerAmount;
    }

    get calculatingScenario(): CalculatingScenario {
        if (this.scenarioSettings.purchase) {
            if (this.isDayTrade) {
                return CalculatingScenario.BuyDayTrade;
            }
            return CalculatingScenario.Buy;
        } else {
            if (this.isDayTrade) {
                return CalculatingScenario.SellDayTrade;
            }
            return CalculatingScenario.Sell;
        }
    }

    public get timeLimitToDaytrade(): string {
        return this.isFuture ? this.DEFAULT_TIME_F_BMF : this.DEFAULT_TIME_F_IBOVESPA;
    }

    private get applicableUnitPrice(): number {
        return this.form.get('searchType').value ? this.form.get('customPrice').value : this.quotePrice;
    }

    /** Identifica se o usuario está usando produtos como garantia */
    public get usingWarranty(): boolean {
        if (this.warranyUsageComponent) {
            return this.warranyUsageComponent.limitIncreased || this.setAuxUsingWarranty;
        }

        return false;
    }

    public set usingWarranty(value) {
        this.setAuxUsingWarranty = value;
    }

    get inputSuffix(): string {
        switch (this.symbol.typeMarket) {
            case OrderMarketTypeEnum.Future:
                if (this.form.get('stocksCount').value === 1) {
                    return ' contrato';
                } else {
                    return ' contratos';
                }
            case OrderMarketTypeEnum.Option:
                return ' opções';
            default:
                return ' ações';
        }
    }

    get inputPriceSuffix(): string {
        if (this.symbol.typeMarket === OrderMarketTypeEnum.Future) return ' pts';

        return '';
    }

    get unitPriceScreen(): string {
        if (this.form.get('searchType').value === 0) {
            if (this.isFuture) return this.unitPrice.toLocaleString('pt') + ' pts';

            return this.unitPrice.toString();
        }
    }

    @ViewChild(TrWarrantyUsageComponent, {static: true}) public warranyUsageComponent: TrWarrantyUsageComponent;

    public tooltipNecessarioParaInvestir: string = `<div>
            <div class='pop-title'>Necessário para investir</div>
            <div class='pop-content'>Valor que você precisa para fazer este investimento. </div>
        </div>`;

    public form: FormGroup;
    public stockId: string;
    public editingScenario: boolean;
    public symbol: any = {};
    public symbolLogo: string = '';
    public parentInstrument: any;
    public parentInstrumentCode: string = '';
    public customPriceValue: any;
    public expirationDateOptionFormatted: Date;
    public authorizationPanel: MatDialogRef<HubAuthorizationComponent>;
    public orderMarketTypeEnum = OrderMarketTypeEnum;
    public availableDays: string[] = [];
    public initialValue: number = 0;

    public legalAdvice: string = 'https://cdn.toroinvestimentos.com.br/corretora/documents/aviso-legal.pdf';

    public daytradeStress: number;
    public defaultStress: number;
    public marketOpen = false;
    public isMobile: boolean;
    public pending: boolean = false;
    public scenarioSettings: CheckoutScenarioSettings = new CheckoutScenarioSettings();
    public neededValueToInvest: number = 0;
    public counter = 0;
    public isSummerTime: boolean;
    public isBovespaBuyPosition: boolean = false;
    public hasBypassedSuitabilityForCurrentInvestment = false;
    public dialogComponentReference: MatDialogRef<InvestmentResumeComponent>;

    public searchTypeOptions: any[] = [
        {item: 'melhor preço disponível', value: 0},
        {item: 'preço personalizado', value: 1},
    ];

    public buyUpOptions: any[] = [
        { item: 'Hoje', value: 0 },
        { item: 'Escolher data', value: 1},
    ];

    protected disposableSubscriptions = new Array<Subscription>();
    private stockMarket: number;
    private setAuxUsingWarranty: any = null;
    private stockStress: any = {};
    private dayTradeTooltip: any;
    private unitPrice: number = 0;
    private ptaxQuote: number = null;
    private exchangeCheckout$: Observable<any>;
    private lastPriceBeforeChange: number = 0;
    private unitPriceBkp: number = 0;
    private MARKET_BOVESPA: string = 'BOVESPA';
    private DOLAR_PTAX: string = 'DOLPTAX';
    private DEFAULT_TIME_F_IBOVESPA = '16:30:59';
    private DEFAULT_TIME_F_BMF = '17:30:59';
    private DEFAULT_TIME_L = '18:30:00';
    private openingTime: string;
    private stockCheckout: StockCheckoutType = new StockCheckoutType();
    private utils$: Observable<UtilsState>;
    private quote$: Observable<StocksMarketState>;
    private marketScenario: any;
    private order: any = null;
    private bestAvaliableMarketPrice: number = 0;
    private quotePrice: number = 0;
    private strategyID: string = null;
    private strategyInput: any = null;
    private applicableStressValue: any;
    private cblc: number = 0;
    private suitability: string = '';

    constructor(
        public formBuilder: FormBuilder,
        public dialogsService: DialogsService,
        private utilitiesService: UtilitiesService,
        private stocksExchangeCheckoutEffects: StocksExchangeCheckoutEffects,
        private store: Store<AppState>,
        protected router: Router,
        private activatedRoute: ActivatedRoute,
        private computerService: ComputerService,
        private location: Location,
        private billingEffects: BillingEffects,
        private routeTracker: RouterTrackerService,
        private interactions: StocksMarketInteractionsService,
        private datePipe: DatePipe,
        private changeDetectionReference: ChangeDetectorRef,
        private icvm617Service: Icvm617Service,
    ) {
        super(dialogsService, router);

        this.activatedRoute.data.subscribe( (data) => {
            this.editingScenario = data.editing as boolean;
        });

        this.editingScenario = this.activatedRoute.snapshot.data.editing;

        // tslint:disable-next-line: prefer-const
        let date = new Date();
        date.setDate(date.getDate() + 1);

        // monta data default do componente de calendário
        while (this.utilitiesService.isWeekendDate(date)) {
            date.setDate(date.getDate() + 1);
        }

        this.form = formBuilder.group({
            stocksCount: 0,
            searchType: [0, Validators.required],
            customPrice: [null, Validators.required],
            buyUp: [0, Validators.required],
            enableDayTrade: true,
            formDatePickerField: date.toISOString(),
        });

        this.disposableSubscriptions.push(
        combineLatest([
            this.store.select((state) => state.utils.timer),
            this.store.select((state) => state.stocksExchange.stocksMarket.instruments).pipe(
            map((items) => items[this.stockId]),
            ),
            this.store.select((state) => state.exchange.tradingTime),
        ]).pipe(
            filter(([time, instrument, tradingTime]) => !!(time && instrument && tradingTime))
        ).subscribe(([time, instrument, tradingTime]) => {
            const limitDayTradeStock = this.normalizeDate((tradingTime.limitDayTradeStock as string));
            const limitDayTradeFuture = this.normalizeDate((tradingTime.limitDayTradeFuture as string));
            this.isSummerTime = this.getTimeZoneHour() === 2;
            // Aplicar horários do exchange
            this.DEFAULT_TIME_F_IBOVESPA = this.datePipe.transform(limitDayTradeStock, 'HH:mm');
            this.DEFAULT_TIME_F_BMF = this.datePipe.transform(limitDayTradeFuture, 'HH:mm');

            let useDate = time;
            let DEFAULT_TIME_F;

            const opening = instrument.typeMarket === OrderMarketTypeEnum.Future ? tradingTime.openingFuture : tradingTime.openingBovespa;
            this.openingTime = this.datePipe.transform(opening, 'HH:mm');

            if (instrument.typeMarket === OrderMarketTypeEnum.Future) {
            DEFAULT_TIME_F = this.DEFAULT_TIME_F_BMF;
            } else {
            DEFAULT_TIME_F = this.DEFAULT_TIME_F_IBOVESPA;
            }

            if (!useDate) {
            const newDate = new Date();
            useDate = this.datePipe.transform(newDate, 'HH:mm:ss');
            }

            if (useDate <= this.DEFAULT_TIME_L && useDate >= DEFAULT_TIME_F) {
            this.marketOpen = false;
            } else {
            this.marketOpen = true;
            }
        }));

        // carrega dados do objeto principal do checkout que carrega os dados principais
        this.disposableSubscriptions.push(this.store.select((state) => state.exchangeCheckout.stockCheckout)
            .subscribe((data) => {
                if (data) {
                    if (data.inputOrder) {
                        this.setUnplanedCheckoutData(data.inputOrder);
                    } else if (data.orderId) {
                        this.stockId = data.symbol.toUpperCase();
                        this.store.dispatch({ type: StocksExchangeWalletAction.getOrder, payload: data.orderId});
                        this.form.updateValueAndValidity();
                    } else {
                        this.stockCheckout = data;
                        this.stockId = this.stockCheckout.symbol.toUpperCase();
                        this.scenarioSettings.purchase = this.stockCheckout.purchase;
                        this.scenarioSettings.alreadyExecuted = false;
                        this.form.get('enableDayTrade')
                            .setValue(this.marketOpen ? true : false);
                        this.store.dispatch({ type: StocksMarketAction.getInstrumentInfo, payload: this.stockId });
                        this.store.dispatch({ type: StocksMarketAction.getQuote, payload: this.stockId});
                    }
                } else {
                    this.location.back();
                }
                this.updateWarrantyFlag();
            }));

        // Pega o CBLC do usuário
        this.disposableSubscriptions.push(
            this.store.select((state) => state.authentication).pipe(
                filter((result) => !!result.currentUser)
            ).subscribe((result) => {
                this.cblc = result.currentUser.cblc;
            }),
        );

        // Pega o suitability
        this.disposableSubscriptions.push(
            this.store.select((state) => state.suitability).pipe(
                filter((result) => !!(result && result.profile))
            ).subscribe((result) => {
                this.suitability = result.profile.description;
            })
        );

        this.disposableSubscriptions.push(merge(
            this.stocksExchangeCheckoutEffects.newOrder$.pipe(
                filter((item) => (item.type as any).equals(StocksExchangeCheckoutAction.newOrderSuccess))
            ),
            this.stocksExchangeCheckoutEffects.editOrder$.pipe(
                filter((item) => (item.type as any).equals(StocksExchangeCheckoutAction.editOrderSuccess))
            ),
        )
        .subscribe((result) => {
            this.pending = false;
            // tslint:disable: no-string-literal
            // Dispatch que é feito pro MixPanel
            const event = new OrderSentEvent(
                SegmentCheckoutTypeEnum.NOT_PLANNED,
                this.stockId,
                this.stockCheckout.origin,
                this.scenarioSettings.purchase ? SegmentOrderSideEnum.BUY : SegmentOrderSideEnum.SELL,
                this.isFuture ? SegmentMarketTypeEnum.BMF : SegmentMarketTypeEnum.BOVESPA,
                this.form.get('stocksCount').value,
                this.cblc,
                this.suitability,
                this.isDayTrade,
                'Old',
                null,
                this.form.get('searchType').value ? 'Custom Price' : 'Best Price',
                null,
                null,
                this.form.get('buyUp').value ? 'Custom Date' : 'Today',
                this.isFractionary(),
                window['toroJWTMobile'],
                this.hasBypassedSuitabilityForCurrentInvestment
            );

            this.store.dispatch({
                type: TrackingActions.sendOrderInformation,
                payload: event,
            });

            if (this.dialogComponentReference) this.dialogComponentReference.componentInstance.haveSuccess(true);

            this.showSuccessScreen();

        }));

        this.disposableSubscriptions.push(merge(
            this.stocksExchangeCheckoutEffects.newOrder$.pipe(
                filter((item) => (item.type as any).equals(StocksExchangeCheckoutAction.newOrderError))
            ),
            this.stocksExchangeCheckoutEffects.editOrder$.pipe(
                filter((item) => (item.type as any).equals(StocksExchangeCheckoutAction.editOrderError))
            ),
        )
        .subscribe((result) => {
            this.pending = false;
            if (this.dialogComponentReference) this.dialogComponentReference.componentInstance.haveSuccess(false);
            this.store.dispatch({ type: ApplicationMessagesAction.genericError, payload: result.payload });
        }));

        this.isMobile = this.utilitiesService.isMobile();

        this.disposableSubscriptions.push(
            this.store.select((state) => state.stocksExchange.stocksMarket.instruments).pipe(
                filter((instrument) => instrument[this.parentInstrumentCode] ? true : false),   
                map((instrument) => instrument[this.parentInstrumentCode])
            ).subscribe((instrument: any) => {
                this.parentInstrument = instrument;
                this.parentInstrumentCode = '';
            })
        );

        this.disposableSubscriptions.push(
            this.store.select((state) => state.stocksExchange.stocksMarket.instruments).pipe(
                filter((instrument) => instrument[this.stockId] ? true : false),
                map((instrument) => instrument[this.stockId])
            ).subscribe((instrument: any) => {
                if (this.symbol.code === instrument.code) return;
  
                this.symbol = instrument;
                this.symbolLogo = this.symbol.logo!.content;
                this.stockStress = (this.symbol.stress as IStressResponse);
                this.stockMarket = this.symbol.typeMarket;
                // this.timeLimitToDaytrade = this.isFuture ? '17:30' : '16:30';
                this.scenarioSettings.isOption = (this.stockMarket === OrderMarketTypeEnum.Option);
                this.quotePrice = instrument.priceLastTrade ||  instrument.openingPrice || instrument.closingPricePreviousDay;
                this.unitPrice = instrument.priceLastTrade ||  instrument.openingPrice || instrument.closingPricePreviousDay;
                this.daytradeStress = (this.symbol.stress as IStressResponse).dayTradeValue;
                this.defaultStress = (this.symbol.stress as IStressResponse).value;
                this.applicableStressValue = this.daytradeStress === 0 ? this.defaultStress : this.daytradeStress;
                if (this.scenarioSettings.isOption) {
                    this.form.get('enableDayTrade')
                        .setValue(false);
                }
                this.form.updateValueAndValidity();
                if (this.form.get('stocksCount').value === 0) {
                    this.form.get('stocksCount')
                        .setValue(this.symbol.standardLot);
                }

                // data chega em formato não válido, por isso temos que quebrar a string
                if (this.scenarioSettings.isOption && this.symbol.expirationDateMarketOption) {
                    const year = this.symbol.expirationDateMarketOption.substring(0, 4);
                    const month = this.symbol.expirationDateMarketOption.substring(4, 6) as number;
                    const day = this.symbol.expirationDateMarketOption.substring(6);
                    this.expirationDateOptionFormatted = new Date(year, month - 1, day);
                    this.scenarioSettings.showTogglePlanningButton = false;
                }
                            
                if (this.isFractionary()) {
                    this.scenarioSettings.showTogglePlanningButton = false;
                    this.parentInstrumentCode = this.symbol.code.substring(0, this.symbol.code.length - 1);
                    if (this.parentInstrumentCode !== undefined) {
                        this.store.dispatch({ type: StocksMarketAction.getInstrumentInfo, payload: this.parentInstrumentCode });
                    }
                }

                this.loadMarketScenario();

                if (this.stockStress.isPtax) {
                    this.subscribePtaxQuote();
                }

                this.HandleSymbolQuote(instrument);
                
                const calculatedValue = this.calculateNeededValueToInvest();
                this.neededValueToInvest = isFinite(calculatedValue) ? calculatedValue : 0;
            }),
        );

        this.disposableSubscriptions.push(
        combineLatest([
            this.store.select((state) => state.stocksExchange.stocksMarket.instruments).pipe(
                filter((item) => !!item[this.stockId]),
                map((item) => item[this.stockId])
            ),
            this.store.select((state) => state.stocksExchange.stocksMarket.quote).pipe(
                filter((item) => !!item[this.stockId]),
                map((item) => item[this.stockId])
            ),
            this.form.valueChanges,
        ]).subscribe(([instrument, quote, form]) => {
            this.HandleSymbolQuote(quote);
            const calculatedValue = this.calculateNeededValueToInvest();
            this.neededValueToInvest = isFinite(calculatedValue) ? calculatedValue : 0;
        })
        );

        this.disposableSubscriptions.push(
            this.stocksExchangeCheckoutEffects.shutDownStrategy$.pipe(
                filter((item) => (item.type as any).equals(StocksExchangeCheckoutAction.shutDownStrategyError))
            ).subscribe((data) => {
                this.store.dispatch({ type: ApplicationMessagesAction.genericError, payload: data.payload });
            }),
        );

        this.disposableSubscriptions.push(
            this.billingEffects.getBrokerageTax$
                .subscribe((action) => {
                    this.showAsideConfirmation(
                        (action.payload.brokerageValue === 0 || action.payload.brokerageValue) ? action.payload.brokerageValue : null,
                    );
                }),
        );

        this.disposableSubscriptions.push(
            this.store.select((state) => state.exchangeCheckout.workingDays).pipe(
                filter((data) => data.length ? true : false)
            ).subscribe((data) => {
                this.availableDays = data;
            }),
        );

        this.form.updateValueAndValidity();
        this.bindFormControlValueChanges();
        this.store.dispatch({ type: UtilsAction.getTimer });
        this.store.dispatch({ type: StocksExchangeCheckoutAction.nextWorkingDays });
    }

    public initTime() {
        const actualTime = new Date();

        let date = actualTime.toLocaleTimeString();
        let DEFAULT_TIME_F;

        DEFAULT_TIME_F = this.DEFAULT_TIME_F_IBOVESPA;

        if (!date) {
            const newDate = new Date();
            date = this.datePipe.transform(newDate, 'HH:mm:ss');
        }

        if (date <= this.DEFAULT_TIME_L && date >= DEFAULT_TIME_F) {
            this.marketOpen = false;
        } else {
            this.marketOpen = true;
            if (this.isFuture) {
                this.form.get('enableDayTrade')
                    .setValue(this.marketOpen);
            }
        }
    }

    public ngAfterContentInit() {

        this.initTime();

        this.form.get('customPrice').valueChanges
            .subscribe((data) => {
                if (data === 0) {
                    this.form.get('customPrice')
                        .setErrors({zeroValue: true});
                }
                if (this.form.get('searchType').value === 1) {
                    this.unitPrice = this.form.controls.customPrice.value;
                }
            });

        this.disposableSubscriptions.push(
            this.store.select((state) => state.stocksExchange.wallet.order).pipe(
                filter((value) => value && this.editingScenario),
                first()
            ).subscribe((data) => {
                this.setUnplanedCheckoutData(data);
            }),

            this.store.select(state => state['suitabilityBypassAgreement']).pipe(
                filter(data => !!data)
            ).subscribe(data => {
                this.hasBypassedSuitabilityForCurrentInvestment = this.symbol.typeMarket === OrderMarketTypeEnum.Future
                    ? data.suitabilityBypassAgreement.bmfAccepted
                    : data.suitabilityBypassAgreement.bovespaAccepted
            })
        );

    }

    public calculateNeededValueToInvest() {
        const param = new ComputingParameter(
            this.form.get('stocksCount').value,
            this.applicableUnitPrice,
            this.symbol.quoteFactor,
            (this.form.get('enableDayTrade').value ? this.applicableStressValue : this.defaultStress),
            null,
            this.ptaxQuote,
        );

        const calc = this.computerService.calculate(this.marketScenario, this.calculatingScenario, param) || 0;

        if (this.dialogComponentReference) {
            this.dialogComponentReference.componentInstance.investmentValue = calc;
        }

        return calc;
    }

    public HandleSymbolQuote(quote: any) {
        // Preço Unitário = Última Cotação senão Preço de Abertura senão Preço de Fechamento
        if (quote) {

            if (quote.Stress) {
                this.stockStress = this.utilitiesService.normalize(quote.Stress);
                this.defaultStress = quote.Stress.Value;
                this.daytradeStress =  quote.Stress.DayTradeValue;
            }
            this.unitPriceBkp =
                (quote.PriceLastTrade || quote.priceLastTrade) ||
                (quote.OpeningPrice || quote.openingPrice) ||
                (quote.ClosingPricePreviousDay || quote.closingPricePreviousDay);

            this.quotePrice =
                (quote.PriceLastTrade || quote.priceLastTrade) ||
                (quote.OpeningPrice || quote.openingPrice) ||
                (quote.ClosingPricePreviousDay || quote.closingPricePreviousDay);

            this.bestAvaliableMarketPrice = this.unitPriceBkp;

            // só altera o valor do unit price com cotação se for ordem a mercado
            if (this.form.controls.searchType.value === 0) {
                this.unitPrice = this.unitPriceBkp;
            } else  if (this.form.controls.customPrice.value === null) {
                this.form.controls.customPrice.setValue(this.unitPriceBkp);
            }
            this.changeDetectionReference.markForCheck();
        }
    }

    public subscribePtaxQuote() {
        this.store.dispatch({ type: StocksMarketAction.getQuote, payload: this.DOLAR_PTAX});
        this.disposableSubscriptions.push(
            this.store.select((state) => state.stocksExchange.stocksMarket.quote).pipe(
                filter((item) => item[this.DOLAR_PTAX]),
                map((item) => item[this.DOLAR_PTAX])
            ).subscribe((quote) => {
                if (quote) {
                    if (quote.PriceLastTrade > 0) {
                        this.ptaxQuote = quote.PriceLastTrade;
                    } else if (quote.OpeningPrice > 0) {
                        this.ptaxQuote = quote.OpeningPrice;
                    } else if (quote.ClosingPricePreviousDay > 0) {
                        this.ptaxQuote = quote.ClosingPricePreviousDay;
                    }
                }
            }),
        );
    }

    /** Valida os dados necessários para confirmação */
    public confirmInvestment() {
        const subscription = this.icvm617Service.userIsBlocked()
        .subscribe((userIsBlockedIcvm617) => {
            if (userIsBlockedIcvm617) {
                this.showWarningUserBlockedIcvm617();
            } else {
                this.pending = true;

                // sem garantia ou fundos suficiente para o investimento
                if (this.neededValueToInvest > this.avaliableValueToInvest) {
                    if (this.usingWarranty)  {
                        this.pending = false;
                        return this.showInsufficientGuaranteeWarning();
                    } else {
                        this.pending = false;
                        return this.showInsufficientFundsWarning();
                    }
                }

                return this.interactions.onInvestmentAttempt(this.stockMarket, this.scenarioSettings.purchase)
                    .then((result) => {
                        if (!result.confirm) {
                            this.pending = false;
                            this.dialogComponentReference = null;
                            return;
                        }

                        const obj = {
                            isDaytrade: this.isDayTrade,
                            orderQty: this.form.get('stocksCount').value,
                            platform: BrokeragePlatform.Hub,
                            price: this.unitPrice,
                            symbol: this.stockId,
                        };

                        this.store.dispatch({ type: BillingAction.getBrokerageTax, payload: obj });
                });
            }
         });

        this.disposableSubscriptions.push(subscription);
    }

    /** Exibe o resumo do investimento para que o usuário confirme os dados */
    public showAsideConfirmation(brokerageTax: number) {
        this.pending = true;

        const obj = {
            investmentValue: +this.neededValueToInvest,
            isDayTrade: this.isDayTrade,
            usingWarranty: this.usingWarranty,
            warrantyValue: this.avaliableValueToInvest,
            planned: false,
            incompatibleProfile: this.scenarioSettings.incompatibleProfile,
            purchase: this.scenarioSettings.purchase,
            unlocked: true,
            isFuture: this.isFuture,
            brokerage: brokerageTax,
            brokerageFactor: this.symbol.brokerageFactor,
        };

        this.dialogComponentReference =
            (this.dialogsService.showComponentAsAsidePanel(InvestmentResumeComponent, true, obj) as MatDialogRef<InvestmentResumeComponent>);

        this.disposableSubscriptions.push(
            this.dialogComponentReference.componentInstance.sendInvestmentSubject
                .subscribe((item) => {
                    if (item) {
                        this.sendInvestmentRequest();
                    }
                }),
        );

        this.disposableSubscriptions.push(
            this.dialogComponentReference.afterClosed()
                .subscribe(() => {
                    this.pending = false;
                    this.dialogComponentReference = null;
                    this.changeDetectionReference.markForCheck();
                }),
        );
    }

    public searchTypeChanged() {
        // antes de mudar para preco customizado guarda valor da cotacao, caso ativo nao
        // tenha liquidez pode nao chegar outra cotacao a tempo
        if (this.form.controls.searchType.value === 0) {
            this.lastPriceBeforeChange = this.unitPrice;
        } else {
            // em caso de edicao, valor pode começar customizado e nao ter cotacao, para isso é usado o unitPriceBkp
            if (this.lastPriceBeforeChange > 0) {
                this.unitPrice = this.lastPriceBeforeChange;
            } else {
                this.unitPrice =  this.unitPriceBkp;
            }
        }
    }

    public loadMarketScenario() {
        if (this.stockMarket === OrderMarketTypeEnum.Stock || this.stockMarket === OrderMarketTypeEnum.Option) {
            this.marketScenario = MarketScenario.StockAndOptions;
        } else {
            if (this.stockStress.isPtax) {
                this.marketScenario = MarketScenario.FuturePtax;
            } else {
                this.marketScenario = MarketScenario.FutureWithoutPtax;
            }
        }
    }

    /** Entra em contato com o serviço e solicita realização do investimento */
    public sendInvestmentRequest() {
        this._suitabilityBypass();
        // tslint:disable-next-line: prefer-const
        let order = new StockOrderType();
        order.symbol = this.stockId;
        order.orderQty = this.form.get('stocksCount').value;
        order.isDaytrade = this.isDayTrade;
        order.suitabilityNonConformityConsent = this.hasBypassedSuitabilityForCurrentInvestment;

        if (!this.daytradeStress || !this.usingWarranty || this.scenarioSettings.isOption) {
            order.isDaytrade = false;
        }
        if (this.form.controls.searchType.value === 1) {
            order.price = this.form.controls.customPrice.value;
            order.priceType = StrategyRequestLegPriceType.Limited;
        } else {
            if (!this.isFuture) {
                order.priceType = StrategyRequestLegPriceType.Market;
            } else {
                order.priceType = StrategyRequestLegPriceType.MarketWithLeftOverAsLimit;
            }
        }

        order.side = OrderSideEnum.Venda;
        if (this.scenarioSettings.purchase) {
            order.side = OrderSideEnum.Compra;
        }

        order.validityType = StrategyRequestLegValidityType.Day;
        order.internalOrderType = StrategyRequestOrderType.Input;
        if (this.editingScenario) {
            order.id = this.order.id;
            if (this.strategyInput) {
                this.store.dispatch({ type: StocksExchangeCheckoutAction.shutDownStrategy, payload: { strategyID: this.strategyID }});
                const subscription: Subscription = this.stocksExchangeCheckoutEffects.shutDownStrategy$.pipe(
                    filter((item) => (item.type as any).equals(StocksExchangeCheckoutAction.shutDownStrategySuccess)),
                    first()
                ).subscribe((data) => {
                    subscription.unsubscribe();
                    this.store.dispatch({ type: StocksExchangeCheckoutAction.editOrder, payload: { data: order } });
                });
                this.disposableSubscriptions.push(subscription);
            } else {
                this.store.dispatch({ type: StocksExchangeCheckoutAction.editOrder, payload: { data: order } });
            }
        } else {
            this.store.dispatch({ type: StocksExchangeCheckoutAction.newOrder, payload: { data: order } });
        }
    }

    public cancel() {
        if (this.editingScenario && !this.strategyID) {
            this.store.dispatch({ type: StocksExchangeCheckoutAction.setStockCheckout, payload: null});
            return this.router.navigateByUrl('/meus-investimentos');
        }
        if (this.routeTracker.getLastRoute(2) === '/checkout') {
            const indexRoute = 2;
            this.routeTracker.getHistory()
                .forEach((item, index) => {
                    if (!item.includes('/checkout')) {
                        this.router.navigateByUrl(item);
                        return false;
                    }
                });
        } else {
            this.routeTracker.back();
        }
    }

    /** Filtra as datas diponíveis para o datepicker */
    public filterAvaliableDates = (d: Date): boolean => {
        const date = new Date(d);
        const day = date.getDate();
        const month = date.getMonth();
        const year = date.getFullYear();

        return this.availableDays.some((dateString) => {
            const actualDate = new Date(dateString);
            return (day === actualDate.getDate() && month === actualDate.getMonth() && year === actualDate.getFullYear());
        });
    }

    /**
     * Caso não encontre a logo para empresa, exibe a logo placeholder.
     * @param event Evento do DOM
     */
    public noLogoHandler(event) {
        this.symbolLogo = STOCK_LOGO_PLACEHOLDER;
    }

    /**
     * Método para ajustar a string do tradingHour que está vindo da webapi
     * GAMBIARRA!! REMOVER QUANDO ARRUMAREM NA API.
     */
    public normalizeDate(date: string) {
        const today = new Date();
        const todayIso = today.toISOString()
                            .split('T');
        const dateISO = date.split('T');
        return `${todayIso[0]}T${dateISO[1]}`;
    }

    /**
     * Recupera o fuso horário do usuário;
     */
    public getTimeZoneHour() {
        const date = new Date();
        const timeZone = date.getTimezoneOffset() / 60;
        return Math.abs(timeZone);
    }

    public ngOnDestroy() {
        this.disposableSubscriptions.forEach((subscription) => {
            if (subscription) subscription.unsubscribe();
        });
        this.store.dispatch({ type: StocksExchangeWalletAction.resetStrategy });
        this.store.dispatch({ type: StocksExchangeWalletAction.resetOrder });
    }

    @HostListener('document:keydown', ['$event'])
    public onKeyPress(event: KeyboardEvent) {
        if (event.shiftKey && event.key === easterEggKey) {
            this.counter++;
            if (this.counter > disclaimerEasterEggTriggerAmount) {
                this.counter = 0;
            }
        }
    }

    public bindFormControlValueChanges() {
        this.bindDayTradeControlValueChanges();
    }

    public bindDayTradeControlValueChanges() {
        const dayTradeFormControl = this.form.get('enableDayTrade');
        dayTradeFormControl
            .valueChanges
            .subscribe( (enableDayTrade) => {
                if (enableDayTrade) {
                    this.updateWarrantyFlag();
                    return;
                }
                this.showDisableAutomaticShutdownDialog()
                    .subscribe((confirm: boolean) => {
                        if (!confirm) {
                            dayTradeFormControl.setValue(!confirm);
                            return;
                        }
                        const calculatedValue = this.calculateNeededValueToInvest();
                        this.neededValueToInvest = isFinite(calculatedValue) ? calculatedValue : 0;
                        this.updateWarrantyFlag();
                        this.changeDetectionReference.markForCheck();
                    });
            });
    }

    /**
     * Shows disable automatic shutdown dialog
     */
    public showDisableAutomaticShutdownDialog(): Observable<any> {
        return this.dialogsService.confirmAction(
            'Você realmente quer desligar o encerramento automático?',
            'Desligando o encerramento automático será necessário um valor maior para investir, aumentando seu risco.',
            'Desligar',
            'Cancelar',
        );
    }

    /** Mostra recibo para o usuário */
    private showSuccessScreen() {
        // Investimento agendado
        if (!this.marketOpen) {
            const operation = this.scenarioSettings.purchase ? 'compra' : 'venda';
            const executedLabel = this.scenarioSettings.purchase ? 'comprado' : 'vendido';
            this.showSuccessMessageResult(
                `Ordem de ${operation} agendada com sucesso.`,
                `A sua ordem de ${operation} foi agendada com sucesso e será processada a partir das ${this.openingTime} do próximo dia útil. 
                Você pode acompanhar esta ordem e conferir se este investimento foi ${executedLabel} na área de Meus Investimentos.`,
                'waiting',
            );
            return;
        }

        // caso não seja uma edição finalizada
        if (this.scenarioSettings.alreadyExecuted) {
            this.showSuccessMessageResult(
                `Investimento editado com sucesso.`,
                `Você pode acessar a área de <strong>Meus Investimentos</strong> dentro de Bolsa para acompanhar o seu investimento.`,
            );
            return;
        }

        if (!this.editingScenario) {
            this.showSuccessMessageResult(
                `Ordem de ${this.scenarioSettings.purchase ? 'compra' : 'venda'} enviada com sucesso.`,
                `A sua ordem de ${this.scenarioSettings.purchase ? 'compra' : 'venda'} foi registrada com sucesso.
                Você pode acompanhar esta ordem e conferir se este investimento foi
                ${this.scenarioSettings.purchase ? 'comprado' : 'vendido'} na área de Meus Investimentos.`,
            );
            return;
        }

        this.showSuccessMessageResult(
            `Compra editada com sucesso.`,
            `Você pode acessar a área de <strong>Meus Investimentos</strong> dentro de Bolsa para editar,
            cancelar e acompanhar se a sua ordem foi executada.
            Depois da execução, você pode criar um planejamento de lucro e prejuízo para a sua ordem. `,
        );
    }

    /**
     * Seta as informações das ordens para as variáveis usadas no unplanedCheckout
     * @param order Ordem recebida;
     */
    private setUnplanedCheckoutData(data) {
        const order = data;

        order.suitabilityNonConformityConsent = this.hasBypassedSuitabilityForCurrentInvestment;
        this.stockId = order.symbol.toUpperCase();
        this.strategyID = order.strategyID;
        this.strategyInput = order.strategyID ? data : null;
        this.order = order;
        this.scenarioSettings.purchase = (order.side === OrderSideEnum.Compra);
        this.scenarioSettings.alreadyExecuted = ((order.status === OrderStatus.Filled) || (order.status === OrderStatus.PartiallyFilled));
        this.scenarioSettings.showTogglePlanningButton = !(this.editingScenario && !this.scenarioSettings.alreadyExecuted);
        this.form.get('enableDayTrade')
            .setValue(order.isDayTrade);
        this.form.get('stocksCount')
            .setValue(order.orderQty);
        if (this.editingScenario) this.initialValue = order.leavesQty;
        if (order.validityType === OrderValidityTypeEnum.GOODTILLDATE) {
            this.form.get('buyUp')
                .setValue(1);
            this.form.get('formDatePickerField')
                .setValue(this.order.expirationDate);
        }

        const price = order.avaragePriceExecuted || order.price;
        this.unitPrice = price;
        if (order.priceType === OrderPriceTypeEnum.Market) {
            this.form.get('searchType')
                .setValue(0);
            this.form.get('customPrice')
                .setValue(price);
        } else {
            this.form.get('searchType')
                .setValue(1);
            this.form.get('customPrice')
                .setValue(price);
        }
        this.store.dispatch({ type: StocksMarketAction.getInstrumentInfo, payload: this.stockId });
        this.store.dispatch({ type: StocksMarketAction.getQuote, payload: this.stockId});

        this.form.updateValueAndValidity();
    }

    // Envia o aceite do usuário de investimento incompativel com perfil de suitability
    private _suitabilityBypass() {
        if (!this.hasBypassedSuitabilityForCurrentInvestment) {
            this.store.dispatch({ type: SuitabilityBypassAgreementActions.updateSuitabilityBypassAgreement, payload: { data: { "marketType": this.isFuture ? "Future" : "Bovespa" } } });
            this.hasBypassedSuitabilityForCurrentInvestment = true;
        }
    }

    /**
     * Ligar Planejamento
     */
    private makePlanedCheckout() {
        // tslint:disable-next-line: prefer-const
        let item = new StockCheckoutType();
        item.symbol = this.stockId;
        item.purchase = this.scenarioSettings.purchase;
        item.isFuture = this.isFuture;

        let url = '/checkout/planejado';

        if (this.editingScenario) {
            item.orderId = this.order.id;
            item.creatingPlanning = true;
            url += '/editar';
        }

        this.store.dispatch({ type: StocksExchangeCheckoutAction.setStockCheckout, payload: item});
        this.router.navigateByUrl(url);
    }

    /**
     * método que controla a flag usada para saber se o usuário Modelo 2 deve usar somente o saldo ou outros investimentos como garantia
     * para casos de Compra, Bovespa e não Daytrade, ele deve usar somente o saldo em conta
     */
    private updateWarrantyFlag() {
        const isBovespa =  this.stockMarket === undefined || this.stockMarket === OrderMarketTypeEnum.Stock;
        this.isBovespaBuyPosition = (isBovespa && !this.isDayTrade && this.scenarioSettings.purchase);
    }

    private isFractionary() {
        // MELHORIA: ALTERAR CACHE DO INSTRUMENT - OBS.: this.symbol.code.endsWith('F') necessário na primeira validação pois o instrument cacheado não está trazendo o typeMarket correto
        return (this.symbol.code.endsWith('F') || this.stockMarket === OrderMarketTypeEnum.Fractionary) ||
        (this.stockMarket === OrderMarketTypeEnum.ETFFractionary && this.symbol.code.endsWith('F'))
    }
}
